import React from 'react'
import { ReviewEl } from './elements'
import SubmissionsStore from '../../stores/SubmissionsStore'
import ReactPlayer from 'react-player'

const Video = () => {
  const { activeSubmission } = SubmissionsStore.useContainer()

  return !activeSubmission ? null : (
    <ReviewEl>
      <div className='videoContent'>
        <ReactPlayer
          url={activeSubmission.url}
          controls
          width={'100%'}
          height={'100%'}
        />
      </div>
    </ReviewEl>
  )
}

export default Video
